import React, { useEffect } from 'react';
import { useAuth } from '@contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './Button';
import { Alert } from './Dialog';
import { Shield } from 'lucide-react';

/**
 * Tela de login — só Entra ID (Microsoft). Não existe senha local.
 */
export const Login: React.FC = () => {
  const { login, isLoading, error, clearError, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Já autenticado → volta para onde estava (ou Hoje).
  useEffect(() => {
    if (user && !isLoading) {
      const from = location.state?.from || '/';
      navigate(from, { replace: true });
    }
  }, [user, isLoading, navigate, location]);

  const handleAzureLogin = async () => {
    try {
      clearError();
      await login();
    } catch (err) {
      console.error('Azure AD login error:', err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center gradient-login-bg p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-card p-8 animate-slide-up">
          <div className="text-center mb-8">
            <img src="/plan_logo.svg" alt="Plan" className="w-16 h-16 rounded-xl mx-auto mb-4" />
            <h1 className="text-h2">Plan — Giannotti</h1>
            <p className="text-slate-500 mt-2">Agenda, finanças e documentos pessoais</p>
          </div>

          {error && (
            <Alert variant="error" className="mb-6" onClose={clearError}>
              {error}
            </Alert>
          )}

          <div className="space-y-4 mb-6">
            <Button
              variant="primary"
              onClick={handleAzureLogin}
              disabled={isLoading}
              className="w-full flex items-center justify-center gap-2"
            >
              <Shield size={20} />
              {isLoading ? 'Conectando...' : 'Entrar com a conta Microsoft'}
            </Button>

            <p className="text-xs text-gray-500 text-center px-2">
              Se a tela da Microsoft não abrir, verifique se os popups estão bloqueados no seu navegador.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-slate-200 text-center">
            <p className="text-small text-slate-500">Uso pessoal · acesso restrito a usuários autorizados.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
